function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M43,6H1C0.447,6,0,6.447,0,7v30c0,0.553,0.447,1,1,1h42c0.552,0,1-0.447,1-1V7C44,6.447,43.552,6,43,6z M42,33.581     L29.612,21.194l-1.414,1.414L41.59,36H2.41l13.392-13.392l-1.414-1.414L2,33.581V8h40V33.581z"
}))), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M39.979,8L22,25.979L4.021,8H2v0.807L21.293,28.1c0.391,0.391,1.023,0.391,1.414,0L42,8.807V8H39.979z"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "fill-current text-blue-light h-12",
    version: 1.1,
    viewBox: "0 0 44 44",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 44 44"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/contact.8db754f5.svg";
export { SvgComponent as ReactComponent };